export default {
      id: "command__active-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#command__active",
      toString: function () {
        return this.url;
      }
    }